import { defineComponent, h } from 'vue';

/**
 * @description This component is used to render a pre tag with the content
 * To preserve new lines (line breaks) in the content caused by formatting tools (eg:prettier, eslint, etc.)
 * @param {string} content - The content of the pre tag
 * @param {string} [as='pre'] - The HTML tag to render the pre tag as
 */
export const CsPreBlock = defineComponent({
  props: {
    as: {
      type: String,
      default: 'pre',
    },
    content: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return () =>
      h(
        props.as,
        {
          attrs: {
            'data-component': 'CsPreBlock',
          },
        },
        props.content
      );
  },
});
